import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, XCircle } from 'lucide-react';
export function Problem() {
  return <section className="py-20 bg-dark" data-id="element-142">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
        {/* The Hook */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20 text-center" data-id="element-144">
          <p className="text-2xl md:text-3xl font-medium leading-relaxed text-offwhite/90 italic border-l-4 border-amber pl-6 text-left" data-id="element-145">
            "Lo conoces bien. Ese momento el lunes por la mañana donde tus
            rodillas crujen, tu espalda se siente como cemento y el dolor en las
            articulaciones te recuerda que 'el asado de ayer' te está pasando
            factura."
          </p>
          <p className="mt-6 text-xl text-offwhite/70 text-left pl-6" data-id="element-146">
            No es solo la edad. Es un incendio silencioso en tu cuerpo provocado
            por los ingredientes ocultos que estás poniendo sobre el fuego sin
            saberlo.
          </p>
        </motion.div>

        {/* The Problem */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20 bg-dark-lighter p-8 md:p-12 rounded-2xl border border-danger/20 relative overflow-hidden" data-id="element-147">
          <div className="absolute top-0 left-0 w-full h-1 bg-danger" data-id="element-148"></div>
          <div className="flex items-center gap-4 mb-6" data-id="element-149">
            <AlertTriangle className="w-10 h-10 text-danger" data-id="element-150" />
            <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-151">
              El Verdadero Culpable
            </h2>
          </div>
          <p className="text-lg text-offwhite/80 mb-6" data-id="element-152">
            Durante años te han dicho que el problema es la carne roja y que la
            solución es comer lechuga y tofu. Pero lo intentas y el dolor sigue
            ahí.
          </p>
          <p className="text-lg text-offwhite/80" data-id="element-153">
            El verdadero culpable no es el chuletón; son los{' '}
            <strong className="text-danger font-bold" data-id="element-154">
              aceites vegetales industriales
            </strong>
            , las{' '}
            <strong className="text-danger font-bold" data-id="element-155">
              salsas BBQ llenas de jarabe de maíz
            </strong>{' '}
            y las{' '}
            <strong className="text-danger font-bold" data-id="element-156">
              marinadas químicas
            </strong>{' '}
            que disparan la inflamación sistémica en hombres mayores de 45 años.
            Estás usando "combustible sucio" en tu ritual más sagrado.
          </p>
        </motion.div>

        {/* Why What You Tried Didn't Work */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-157">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-158">
            Por qué lo que has intentado NO funciona
          </h2>
          <div className="space-y-6" data-id="element-159">
            {['Las dietas restrictivas fallan porque eliminan el placer y la proteína que necesitas para mantener tu músculo.', "Los analgésicos solo tapan el síntoma mientras el 'incendio' interno sigue dañando tus tejidos.", 'Los consejos de salud genéricos no entienden la biología del hombre de 45+ y su sensibilidad a los aceites de semillas.'].map((item, index) => <div key={index} className="flex items-start gap-4 bg-dark-warm p-6 rounded-xl border border-white/5" data-id="element-160">
                <XCircle className="w-8 h-8 text-danger shrink-0 mt-1" data-id="element-161" />
                <p className="text-lg text-offwhite/90" data-id="element-162">{item}</p>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}